// extracted by mini-css-extract-plugin
export var topLevelSection = "AboutLayout-module--top-level-section--JTUzS";
export var mainSection = "AboutLayout-module--main-section--6hXCu";
export var mainSection1EggContainer = "AboutLayout-module--main-section-1-egg-container--aCq8B";
export var mainSection2VerticalEggContainer = "AboutLayout-module--main-section-2-vertical-egg-container--cdXEV";
export var mainSection2HorizontalEggContainer = "AboutLayout-module--main-section-2-horizontal-egg-container--MGruO";
export var mainSection2VerticalEggImage = "AboutLayout-module--main-section-2-vertical-egg-image--Q2meA";
export var mainSection3EggContainer = "AboutLayout-module--main-section-3-egg-container--1bHdJ";
export var link = "AboutLayout-module--link--6KVRw";